import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { ButtonProps, DescriptionProps, TitleProps } from '../../types';

export const Title = ({ title }: TitleProps) => (
    <div className="sales-eligible-banner__title-container">
        <span>
            <Typography
                variant="body-lg"
                color="neutral-800"
                className="sales-eligible-banner__title"
            >
                {title}
            </Typography>
        </span>
    </div>
);

export const Description = ({ description }: DescriptionProps) => (
    <div className="sales-eligible-banner__description-container">
        <span>
            <Typography
                variant="body-md"
                color="neutral-700"
                className="sales-eligible-banner__description"
            >
                {description}
            </Typography>
        </span>
    </div>
);

export const CTAButton = ({
    buttonText,
    handleButtonClick,
    isNarrow,
}: ButtonProps & { isNarrow: boolean }) => (
    <Button
        size={isNarrow ? 'block' : 'responsive'}
        onClick={handleButtonClick}
        variant="secondary"
    >
        <div className="billing-history__button-content">
            <p className="button-copy">{buttonText}</p>
        </div>
    </Button>
);

export const DismissButton = ({
    buttonText,
    handleButtonClick,
    isNarrow,
}: ButtonProps & { isNarrow: boolean }) => (
    <Button
        size={isNarrow ? 'block' : 'responsive'}
        onClick={handleButtonClick}
        variant="ghost"
    >
        <div className="billing-history__button-content">
            <p className="button-copy">{buttonText}</p>
        </div>
    </Button>
);
